module.exports = __webpack_public_path__ + "static/img/baby_4.dc6d28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baby_4.png
// module id = n37m
// module chunks = 1